import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Input, Button, Table } from "reactstrap";

import { ApiContext } from "../../contexts/ApiContext";
import { useNotification } from "../../contexts/NotificationContext";
import AccountService from "../../service/account.service";

const DEFAULT_HOURS = [
  { dayOfWeek: 0, label: "Domingo", open: "08:00", close: "22:00", closed: false },
  { dayOfWeek: 1, label: "Segunda-feira", open: "08:00", close: "22:00", closed: false },
  { dayOfWeek: 2, label: "Terça-feira", open: "08:00", close: "22:00", closed: false },
  { dayOfWeek: 3, label: "Quarta-feira", open: "08:00", close: "22:00", closed: false },
  { dayOfWeek: 4, label: "Quinta-feira", open: "08:00", close: "22:00", closed: false },
  { dayOfWeek: 5, label: "Sexta-feira", open: "08:00", close: "22:00", closed: false },
  { dayOfWeek: 6, label: "Sábado", open: "08:00", close: "22:00", closed: false },
];

export const BusinessHoursForm = ({ onSaved, showSaveButton = true }) => {
  const { account, user, getUser } = useContext(ApiContext);
  const { notify } = useNotification();
  const [hours, setHours] = useState(DEFAULT_HOURS);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!account) return;
    if (Array.isArray(account.businessHours) && account.businessHours.length > 0) {
      setHours(account.businessHours);
    } else {
      setHours(DEFAULT_HOURS);
    }
  }, [account]);

  const updateDay = (dayOfWeek, patch) => {
    setHours((prev) => prev.map((d) => (d.dayOfWeek === dayOfWeek ? { ...d, ...patch } : d)));
  };

  const handleSave = async () => {
    if (!account?.id) return;
    setSaving(true);
    try {
      await AccountService.update(account.id, { businessHours: hours });
      notify("tr", "success", "Horário de atendimento salvo!", "icon-check-2");
      if (user?.id) await getUser(user.id);
      onSaved?.();
    } catch (err) {
      console.error(err);
      notify("tr", "danger", "Erro ao salvar horário", "icon-alert-circle-exc");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <p className="text-muted" style={{ fontSize: 14, marginBottom: 16 }}>
        Defina quando o cardápio digital aceita pedidos. Fora desses horários, o cliente vê a loja como fechada.
      </p>
      <Table responsive className="table-hours">
        <thead>
          <tr>
            <th style={{ width: "30%" }}>Dia</th>
            <th style={{ width: "25%" }}>Abertura</th>
            <th style={{ width: "25%" }}>Fechamento</th>
            <th style={{ width: "20%", textAlign: "center" }}>Fechado</th>
          </tr>
        </thead>
        <tbody>
          {hours.map((day) => (
            <tr key={day.dayOfWeek}>
              <td style={{ verticalAlign: "middle" }}>{day.label}</td>
              <td style={{ verticalAlign: "middle" }}>
                <Input
                  type="time"
                  value={day.open}
                  disabled={day.closed}
                  style={{ maxWidth: 160 }}
                  onChange={(e) => updateDay(day.dayOfWeek, { open: e.target.value })}
                />
              </td>
              <td style={{ verticalAlign: "middle" }}>
                <Input
                  type="time"
                  value={day.close}
                  disabled={day.closed}
                  style={{ maxWidth: 160 }}
                  onChange={(e) => updateDay(day.dayOfWeek, { close: e.target.value })}
                />
              </td>
              <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                <input
                  type="checkbox"
                  className="form-check-input m-0"
                  checked={day.closed}
                  onChange={(e) => updateDay(day.dayOfWeek, { closed: e.target.checked })}
                  style={{ width: 18, height: 18, cursor: "pointer" }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {showSaveButton && (
        <Button className="btn-fill" color="primary" onClick={handleSave} disabled={saving}>
          {saving ? "Salvando..." : "Salvar horário"}
        </Button>
      )}
    </>
  );
};

const BusinessHoursSettings = () => (
  <div className="content">
    <Row>
      <Col md="12">
        <div className="card">
          <div className="card-header">
            <h5 className="title">Horário de atendimento</h5>
          </div>
          <div className="card-body">
            <BusinessHoursForm />
          </div>
        </div>
      </Col>
    </Row>
  </div>
);

export default BusinessHoursSettings;
